import { Button, Grid, Paper, TextField } from "@mui/material"
import HeaderAdd from "../../Common/HeaderAdd/HeaderAdd"
import useLang from "../../../hooks/useLang"

interface Props {
  handleSubmit: (e: any) => void
  handleInputChange: (e: any) => void
  title_fr: string
  title_en: string
  description_fr: string
  description_en: string
  loading: boolean
  title: string
}

export default function FormFaqs({
  handleSubmit,
  handleInputChange,
  title_en,
  title_fr,
  description_en,
  description_fr,
  loading,
  title,
}: Props) {
  const { getText } = useLang()
  return (
    <Grid container spacing={3}>
      <Grid item xs={1} md={2} lg={3} />
      <Grid item xs={12} md={8} lg={6}>
        <Paper
          sx={{
            px: 2,
            py: 3,
            position: "relative",
          }}
        >
          <form onSubmit={handleSubmit}>
            <Grid container spacing={3}>
              <Grid item xs={12} lg={12}>
                <HeaderAdd title={title} />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required={true}
                  name="title_fr"
                  type="text"
                  onChange={handleInputChange}
                  label={getText("Titre en FR")}
                  fullWidth
                  variant="outlined"
                  value={title_fr}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required={true}
                  name="title_en"
                  type="text"
                  onChange={handleInputChange}
                  label={getText("Titre en EN")}
                  fullWidth
                  value={title_en}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required={true}
                  name="description_fr"
                  type="text"
                  onChange={handleInputChange}
                  label={getText("Description en FR")}
                  fullWidth
                  value={description_fr}
                  variant="outlined"
                  minRows={4}
                  multiline
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required={true}
                  name="description_en"
                  type="text"
                  onChange={handleInputChange}
                  label={getText("Description en EN")}
                  fullWidth
                  value={description_en}
                  variant="outlined"
                  minRows={4}
                  multiline
                />
              </Grid>
              <Grid
                display={"flex"}
                justifyContent={"center"}
                item
                xs={12}
                lg={12}
              >
                <Button
                  type="submit"
                  style={{ background: "#5D490E" }}
                  disabled={loading}
                  variant="contained"
                >
                  {getText("Valider")}
                </Button>
              </Grid>
            </Grid>
          </form>
        </Paper>
      </Grid>
      <Grid item xs={1} md={2} lg={3} />
    </Grid>
  )
}
